import { aC as a, aO as n } from "./StickyHeaderSkeleton-f12bcf9d.mjs";
import { r as o, A as e } from "./Header-490425af.mjs";
function u(r) {
  const {
    lang: s
  } = a();
  return o({
    queryKey: [e.CLIENT_V1_COURSE_CATEGORY, {
      lang: s
    }, "GNB_COURSE_CATEGORIES"],
    url: n(e.CLIENT_V1_COURSE_CATEGORY),
    options: {
      ...r,
      suspense: !1,
      cacheTime: 1 / 0,
      staleTime: 1 / 0,
      useErrorBoundary: !1
    }
  });
}
export {
  u
};
